import { useSearchParams } from 'next/navigation';

import { ChooseCategorySearchParams } from '@/ducks/voyageInfo/category/searchParams';
import { type TFareClassName } from '@/features/fareClasses/types';

export const useGetAppliedFareClass = (): TFareClassName | undefined =>
  useSearchParams().get(ChooseCategorySearchParams.fareClass)?.toUpperCase() as TFareClassName;
